export const TabsData = [
     {
          title: "Project Details",
          id: 1,
          tab: "project details"
     },
     {
          title: "Deep Search",
          id: 11,
          tab: "deep search"
     },
     {
          title: "Literature Search",
          id: 2,
          tab: "literature search"
     },
     {
          title: "Study Design",
          id: 3,
          tab: "study design"
     },
     {
          title: "Data Collection",
          id: 4,
          tab: "Data collection"

     },
     {
          title: "Data Analysis",
          id: 5,
          tab: "Data analysis"
     },
     {
          title: "People",
          id: 6,
          tab: "people"
     },
     {
          title: "Planner",
          id: 7,
          tab: "planner"
     },
     {
          title: "Registered Events",
          id: 8,
          tab: "register events"
     },
     {
          title: "Document",
          id: 9,
          tab: "documents"
     },
     // {
     //   title: "Mentors",
     //   id: 10,
     //   tab: "mentors"
     // }

];